import { Registration } from '../../types/AssessmentTable.type';
import AssessmentStudentTable from './AssessmentStudentTable';

type Props = {
  handleOpenLevelModal: (
    subsubtypeId: number,
    registration: Registration,
  ) => void;
  refreshKey: number;
};

const SOFTable = ({ handleOpenLevelModal, refreshKey }: Props) => (
  <AssessmentStudentTable
    program="SOF"
    refreshKey={refreshKey}
    handleOpenLevelModal={handleOpenLevelModal}
  />
);

export default SOFTable;
